import React from 'react';
import { useI18n } from '../../../../../../data/hooks/i18nHooks';

function ScheduleItemFullInfo(props) {
    const { session } = props,
        i18n = useI18n(),
        { is_full } = session;

    if (!is_full) return null;

    return (
        <div className="content">
            <div
                style={{
                    color: 'white',
                    backgroundColor: 'red',
                    textTransform: 'uppercase',
                    textAlign: 'center',
                    fontWeight: 'bold',
                    lineHeight: '30px',
                }}>
                {i18n['label.full']}
            </div>
        </div>
    );
}

export default ScheduleItemFullInfo;
